<div class="dashBoard main-wrapper">
    <app-sidebar class="side-menu"></app-sidebar>

    <div class="main-container container-fluid p-0">

        <router-outlet></router-outlet>

        <app-chat></app-chat>

    </div>
</div>
